import { AppHelper } from "../appHelper.js"
import { Grid } from "../core/components/grid.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { AppBaseProps, CommonApp, Context } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { General } from "../../siteManagement/general.js";
import { Config } from "../core/config/config.js";
import { HTTPService } from "../core/util/httpManager.js";
import { FieldInstance } from "../core/components/field.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class HistoryApp extends React.Component<EmailHistoryAppProps, HistoryAppState> {
    //private currentContext: string = null;
    private itemKey = null;
    common = new AppHelper();
    setTabTitle = true;
    emailHistoryOptions: kendo.ui.GridOptions = null;
    translations: StringKeyDictionary<string> = null;
    reviewEnabled = true;

    constructor(props: EmailHistoryAppProps) {
        super(props);

        this.common.init(this);

        if (Helper.hasValue(props.context.jobId)) {
            this.openEMail(props.context.jobId);
        }
        this.itemKey = Helper.hasValue(props.context.itemKey) && props.context.itemKey !== "" ? props.context.itemKey : null;
        this.state = {
            gridData: [],
            currentContext: Helper.hasValue(props.context.appContext) && props.context.appContext !== "" ? props.context.appContext : null
        }
        this.initApp();
    }

    private initApp = () => {
        if (this.state.currentContext == "ticket") {
            this.emailHistoryOptions.columns.splice(1, 0, { field: "SenderName", title: this.translations["WebCRM.Email.GesendetVon"] });
        }
    }

    private getGridData = async () => {
        const url = `EmailSender/GetAllEmails?${Helper.hasValue(this.state.currentContext) ? "context=" + this.state.currentContext : ""}${Helper.hasValue(this.itemKey) ? "&itemKey=" + this.itemKey : ""}`;
        const result = await HTTPService.get(url);
        this.setState({ gridData: result });
    }

    private selectionChanged = (dataItem: EmailInfo) => {
        if (Helper.hasValue(dataItem)) {
            this.openEMail(dataItem.JobId);
        }
    }

    private openEMail = (jobId: number) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl('EmailSender/Show?isWindow=true&id=' + jobId.toString(), null, { disableTabTitle: true });
        sheet.setTitle(this.translations["WebCRM.Email.Email"]);
    }
    createGrid = () => {
        const dropDownProps = ComponentHelper.createFactory().getDefaultDropDownProps();
        dropDownProps.field.dataSourceUrl = "EmailSender/GetTemplateTypes";
        dropDownProps.field.optionLabel = this.translations["WebCRM.Email.NoContext"];//Config.translations.pleaseSelect;
        dropDownProps.field.listWidth = 375;
        dropDownProps.value = this.state.currentContext;
        dropDownProps.onChange = (_, value: string) => {
            let context = value;
            if (value === "") {
                context = null;
            }
            this.setState({ currentContext: context }, this.refresh)
        };

        return (
            <div className="flex-container">
                {
                    this.common.isWindow ?
                        null :
                        <div style={{ marginBottom: 10, marginTop: 10, maxWidth: 400 }}>
                            <div className="flex-container flex-container--row flex-container--align-center">
                                <FieldInstance label={this.translations["WebSMS.ReportMetadata.TargetEntityType"]}>
                                    <DropDownList {...dropDownProps} />
                                </FieldInstance>

                            </div>
                        </div>
                }
                <div className="flex-container__item flex-containter" >
                    <Grid id="emailHistory" data={this.state.gridData} options={this.emailHistoryOptions} onSelectionChanged={this.selectionChanged} />
                </div>
            </div>
        );
    }

    create = () => {
        if (this.common.isWindow) {
            Helper.openInNewBrowserTab(Config.baseUrl + "EmailSender/New/");
        } else {
            window.location.href = Config.baseUrl + "EmailSender/New/";
        }
    }

    refresh = () => {
        this.getGridData();
    }

    componentDidMount() {
        this.refresh();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}

interface HistoryAppState {
    gridData: Array<EmailInfo>;
    currentContext: string
}

interface EmailInfo {
    Submittedby: string;
    JobId: number;
}

export interface EmailHistoryAppProps extends AppBaseProps {
    context: EmailHistoryPropsContext;
}

interface EmailHistoryPropsContext extends Context {
    jobId: number;
    itemKey: string;
    appContext: string;
}